import React from 'react'
import { Controller } from 'react-hook-form'

import { MessageTemplateEditor } from './common/MessageTemplateEditor/MessageTemplateEditor'
import type { MessageTemplateEditorProps } from './types'
import type { ControlledFieldProps } from '../../types'

export const Editors = React.forwardRef<
  HTMLDivElement,
  MessageTemplateEditorProps
>(
  (
    {
      error,
      id,
      name,
      placeholder,
      value,
      variables,
      onBlur,
      onChange,
      isDisabled,
      isRequired,
    },
    ref,
  ) => (
    <MessageTemplateEditor
      {...{
        error,
        id,
        name,
        placeholder,
        ref,
        value,
        variables,
        onBlur,
        onChange,
        isDisabled,
        isRequired,
      }}
    />
  ),
)

type ControlledEditorsProps = ControlledFieldProps &
  Pick<MessageTemplateEditorProps, 'placeholder' | 'variables'>

export const ControlledEditors = ({
  control,
  error,
  id,
  name,
  placeholder,
  variables,
  isDisabled,
  isRequired,
}: ControlledEditorsProps) => (
  <Controller
    render={({ field: { name, ref, value, onBlur, onChange } }) => (
      <Editors
        {...{
          error,
          id,
          name,
          placeholder,
          ref,
          value,
          variables,
          onBlur,
          onChange,
          isDisabled,
          isRequired,
        }}
      />
    )}
    {...{ control, name }}
  />
)
